/* eslint-disable react/display-name */
// react
import React, { useEffect, useState } from 'react'
import { CSVLink } from 'react-csv'
import { Button, BUTTON_THEME } from '@st-operations/uikit/src/v2/index.js'

// components
import ListView from '_components/list-view/index.jsx'
import Header from '_components/header/index.jsx'
import { getDataMonitoringFilters } from '_services/data-explorer'

// Styles
import './styles.scss'
import format from '@st-operations/uikit/lib/format'

const DataMonitoring = () => {
  const [contentRuleLogsData, setContentRuleLogsData] = useState([])

  let dataToDownload = contentRuleLogsData?.map((content) => {
    const { partner, size, status, deviation, report_generation_timestamp, delivery_date } = content
    return {
      partner,
      size,
      status,
      deviation,
      reportGenerationTimestamp: report_generation_timestamp,
      deliveryDate: delivery_date,
    }
  })
  const dataToDownloadOrdered = dataToDownload

  let headers = [
    { label: 'Partner', key: 'partner' },
    { label: 'Size', key: 'size' },
    { label: 'Status', key: 'status' },
    { label: 'Deviation', key: 'deviation' },
    { label: 'Report Timestamp', key: 'reportGenerationTimestamp' },
    { label: 'Delivery Date', key: 'deliveryDate' },
  ]

  const csvReport = {
    filename: 'data-monitoring.csv',
    headers,
    data: dataToDownloadOrdered ? dataToDownloadOrdered : [],
  }

  const handleGetItems = (items) => {
    setContentRuleLogsData(items)
  }

  const [filters, setFilters] = useState()
  useEffect(() => {
    async function exec() {
      setFilters(await getDataMonitoringFilters())
    }
    exec()
  }, [])

  return (
    <div id="data-monitoring-page" className="data-monitoring">
      <Header>
        <div className="data-monitoring__header">
          <h1 className="title">Monitoring</h1>
          <CSVLink {...csvReport}>
            <Button theme={BUTTON_THEME.PRIMARY}>Download as CSV</Button>
          </CSVLink>
        </div>
      </Header>
      <ListView
        columns={[
          {
            name: 'Partner',
            key: 'partner',
            styles: { maxWidth: '200px' },
          },
          {
            name: 'Size',
            key: 'size',
            styles: {
              maxWidth: '100px',
              textAlign: 'right',
            },
            render: (item) => format('metric', item.size),
          },
          {
            name: 'Status',
            key: 'status',
            styles: {
              maxWidth: '100px',
              textAlign: 'right',
            },
          },
          {
            name: 'Deviation',
            key: 'deviation',
            styles: {
              maxWidth: '100px',
              textAlign: 'right',
            },
          },
          {
            name: 'Report Timestamp',
            key: 'report_generation_timestamp',
            styles: {
              maxWidth: '200px',
              textAlign: 'right',
            },
          },
          {
            name: 'Delivery Date',
            key: 'delivery_date',
            styles: {
              maxWidth: '200px',
              textAlign: 'right',
            },
          },
        ]}
        entities="data-explorer/monitoring/records"
        filters={[
          {
            name: 'delivery_name',
            label: 'Partner',
            options: filters?.deliveryNames?.map((m) => m.partner) || [],
            all: true,
          },
          {
            name: 'status',
            label: 'Status',
            options: filters?.statuses?.map((m) => m.status),
            all: true,
          },
          {
            name: 'delivery_date',
            label: 'Delivery Date',
            type: 'date',
          },
        ]}
        searchable={false}
        onGetItems={handleGetItems}
        extractItems={(resp) => resp}
        extractCount={(resp) => resp.length}
      />
    </div>
  )
}

// export
export default DataMonitoring
